class Hack {
  constructor() {
    this._completes = [];
    this._state = 0;

    const agent = window.navigator.userAgent.toLowerCase();
    this.isRmt = -1 != agent.indexOf("rmt"); // RMT
    this.isWechat = -1 != agent.indexOf("micromessenger"); // wechat
    this.isAndroid = -1 != agent.indexOf("android"); // android
    this.isIphone =
      -1 != agent.indexOf("iphone") || -1 != agent.indexOf("ipad"); // iphone
    this.isPc = !(!agent.match("mac") && !agent.match("win")); // PC

    // this.isRmt = true;
    // this.isWechat = true;
  }

  load() {
    // loading
    if (0 !== this._state) return;

    this._state = -1;
    const complete = () => {
      this._state = 1;
      for (let i = 0; i < this._completes.length; i++) {
        this._completes[i]();
      }
    };

    if (this.isRmt) {
      $$.util.loadScript(
        "https://assets.shmedia.tech/qiaojie/rmt-2.0.0.js",
        () => {
          setTimeout(complete, 100);
        }
      );
    } else if (this.isWechat) {
      $$.util.loadScript(
        "https://res.wx.qq.com/open/js/jweixin-1.6.0.js",
        () => {
          complete();
        }
      );
    }
  }

  execute(callback) {
    this._state > 0
      ? callback()
      : (() => {
          this._completes.push(callback);
          this.load();
        })();
  }

  share(shareData) {
    // share - rmt
    const shareRmt = () => {
      window.rmt.configUI({
        moreBox: {
          wechat: "enable",
          wechatMoment: "enable",
          qq: "enable",
          qqZone: "enable",
          weibo: "enable",
          copyLink: "enable"
        }
      });

      window.rmt.configShare({
        wechat: shareData,
        wechatMoment: shareData,
        qq: shareData,
        qqZone: shareData,
        weibo: shareData
      });
    };

    // share - wechat
    const shareWechat = () => {
      $$.http.post("/forward/weiXin", {
        data: {
          url: encodeURIComponent("" || window.location.href)
        },
        success: data => {
          const wechat = data[0];

          window.wx.config({
            debug: false,
            appId: wechat.appId,
            timestamp: wechat.timestamp,
            nonceStr: wechat.NonceStr,
            signature: wechat.signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          });
          const { title, summary, link, imageUrl } = shareData;
          const shareInfo = {
            title,
            desc: summary,
            link,
            imgUrl: imageUrl
          };
          window.wx.ready(function() {
            window.wx.updateAppMessageShareData(shareInfo);
            window.wx.updateTimelineShareData(shareInfo);
          });
        }
      });
    };

    this.execute(() => {
      if (this.isRmt) {
        shareRmt();
      } else if (this.isWechat) {
        shareWechat();
      }
    });
  }

  open({ url = "", closing = true }) {
    this.execute(() => {
      const isActionURL = url.startsWith("rmt://");
      if (!this.isRmt && isActionURL) {
        window.rmt.openAction({ actionUrl: url, closing });
      } else {
        isActionURL && (url = $$.util.getParam("target", url));
        window.location.href = url;
      }
    });
  }
}

export default new Hack();
